module.exports = __webpack_public_path__ + "img/BYOCS_SmokingEtOH.8053a81c.jpg";